import React, { useContext, useEffect, useState } from "react";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { useNavigate, useParams } from "react-router-dom";
import ClientAuthContext from "../../context/ClientAuthContext";
import "../../css/items.scss";
import { serverInstance } from "../../service/axios";
import { isNotEmpty } from "../../utils/Utils";
import "./payment.scss";

const Payment = ({ data, priceData }) => {

  const navigate = useNavigate();
  const params = useParams();
  const { userData } = useContext(ClientAuthContext)

  const [plan, setPlan] = useState(null);
  const [qpayInvoice, setQpayInvoice] = useState(null);
  const [invoiceId, setInvoiceId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [errorMsg, setErrorMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const [gotPlan, setGotPlan] = useState(false);
  const [gettingInvoice, setGettingInvoice] = useState(false);
  const [checking, setChecking] = useState(false);
  const [paid, setPaid] = useState(false);
  const [membershipActive, setMembershipActive] = useState(false);
  const [newPaidUntil, setNewPaidUntil] = useState("");

  useEffect(() => {
    if (plan && userData?.email) {
      if (!gotPlan) {
        setGotPlan(true);
      }

      let paidUntil = userData.paid_until && new Date(userData.paid_until) > new Date() ? new Date(userData.paid_until) : new Date();
      paidUntil.setFullYear(paidUntil.getFullYear() + plan.term);
      setNewPaidUntil(paidUntil.toLocaleString('mn-MN', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      }));
    }
  }, [plan, userData?.email]);

  useEffect(() => {
    if (params.id) {
      findPlan(params.id);
      window.scrollTo(0, 0);
    }
  }, [params.id]);

  useEffect(() => {
    if (userData && userData.paid_until) {
      setMembershipActive(new Date(userData.paid_until) > new Date());
    }
  }, [userData]);

  const findPlan = (id) => {
    serverInstance.post("/app/item", { class: "plan", id: id }, {
      headers: {
        "Content-Type": "application/json",
      }
    })
      .then((res) => {
        setPlan(res.data.item);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setErrorMsg("Гишүүнчлэлийн төрөл олдсонгүй. Та гишүүнчлэлийн хуудаснаас дахин сонгоно уу.");
        setLoading(false);
      })
  }

  const handleInvoice = () => {
    if (!userData?.email || !plan) {
      return;
    }

    if (qpayInvoice?.qr_image) {
      return;
    }

    if (gettingInvoice) {
      return;
    }
    //TODO what if user is extending membership?
    // mannually create invoice

    const invoice_id = localStorage.getItem("invoice_id");

    if (isNotEmpty(invoice_id)) {
      console.log("Found invoice", invoice_id)
      // if invoice is expired or plan is different, create new invoice
      getExistingInvoice(invoice_id);
    }
    else {
      createNewInvoice();
    }
  }

  const createNewInvoice = () => {
    setGettingInvoice(true);
    serverInstance.post("/sponsor/invoice", {
      plan_id: plan.id
    }, {
      headers: {
        "Authorization": `Bearer ${localStorage.getItem("lingoPortalToken")}`,
        'Content-Type': 'application/json'
      }
    })
      .then((res) => {
        console.log("New invoice", res.data.invoice_id);
        setInvoiceId(res.data.invoice_id);
        setQpayInvoice(res.data.qpay_invoice);
        setErrorMsg("");
        setGettingInvoice(false)
        localStorage.setItem("invoice_id", res.data.invoice_id);
      })
      .catch((err) => {
        console.log(err);
        setGettingInvoice(false)
        if (err.response.status === 401) {
          setErrorMsg("Та дахин нэвтрээд оролдоно уу!");
        }
        else {
          setErrorMsg("Төлбөрийн нэхэмжлэх үүсгэхэд алдаа гарлаа!");
        }
      })
  }

  const getExistingInvoice = (invoice_id) => {
    setGettingInvoice(true);
    serverInstance.get(`/client/invoice?invoiceId=${invoice_id}`, {
      headers: {
        "Authorization": `Bearer ${localStorage.getItem("lingoPortalToken")}`,
        'Content-Type': 'application/json'
      }
    })
      .then((res) => {
        if (res.status === 200) {
          // if invoice is expired or plan is different, create new invoice
          const qpayInvoice = JSON.parse(res.data.invoice.text_value);
          if (plan.price === res.data.invoice.amount && res.data.invoice.email === userData.email) {
            console.log("Same invoice " + res.data.invoice.email, res.data.invoice.id)
            setInvoiceId(res.data.invoice.id);
            setQpayInvoice(qpayInvoice);
            setErrorMsg("");
          }
          else {
            localStorage.removeItem("invoice_id");
            createNewInvoice();
          }
        }
        else {
          setSuccessMsg("");
          setErrorMsg("Төлбөрийн нэхэмжлэх үүсгэхэд алдаа гарлаа. Код: " + res.status);
        }
        setGettingInvoice(false)
      })
      .catch((err) => {
        console.log(err);
        setGettingInvoice(false)
        if (err.response.status === 401) {
          setErrorMsg("Та дахин нэвтрээд оролдоно уу!");
        }
        else if (err.status === 404) {
          localStorage.removeItem("invoice_id");
          createNewInvoice();
        }
        else {
          setErrorMsg("Төлбөрийн нэхэмжлэх үүсгэхэд алдаа гарлаа! " + err.response.status);
        }
      })
  }

  const checkInvoice = () => {
    setChecking(true)
    serverInstance.post("/sponsor/invoice/check", {
      invoice_id: invoiceId
    }, {
      headers: {
        "Authorization": `Bearer ${localStorage.getItem("lingoPortalToken")}`,
        'Content-Type': 'application/json'
      }
    })
      .then((res) => {
        if (res.data.paid === true) {
          setSuccessMsg("Төлбөр амжилттай төлөгдсөн байна");
          setErrorMsg("");
          setPaid(true);
          localStorage.removeItem("invoice_id");
        }
        else {
          setSuccessMsg("");
          setErrorMsg("Төлбөр төлөгдөөгүй байна!");
          setPaid(false);
        }
        setChecking(false)
      })
      .catch((err) => {
        console.log(err);
        setChecking(false);
      })
  }

  return (
    <div className='items-container payment-container'>
      <div className="upper-section">
        <div className="upper-section-inner">
          <div className="title-container">
            <h2>{data.title}</h2>
          </div>
        </div>
      </div>
      {loading ?
        <AiOutlineLoading3Quarters size={25} className="loading-spinner" />
        :
        <div className='payment'>
          {membershipActive ?<div className="membership">
            Таны гишүүнчлэл {new Date(userData.paid_until).toLocaleString('mn-MN', {
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric',
                    })} хүртэл хүчинтэй байна.
          </div> : null}

          {plan ? <>
            <div className="info-title">{data.extend}</div>
            <div className="info">{data.type}: {plan.type === "company" ? priceData.company : priceData.person}</div>
            <div className="info">{priceData.term}: {plan.term === 100 ? priceData.lifeLong : plan.term + " " + priceData.year}</div>
            <div className="info">
              {priceData.price}: {new Intl.NumberFormat('mn-MN', { style: 'decimal', maximumFractionDigits: 0 }).format(plan.price)} ₮
            </div>
            <div className="info">{data.newDate}: {newPaidUntil}</div>
          </> : null}

          {errorMsg ? <div className="error-msg">{errorMsg}</div> : null}
          {successMsg ? <div className="success-msg">{successMsg}</div> : null}

          {paid ? null :
            <>
              {qpayInvoice?.qr_image ?
                <img className="qr-code"
                  src={`data:image/png;base64,${qpayInvoice?.qr_image}`}
                  alt="QR Code"
                  style={{ width: '300px', height: '300px' }}
                />
                :
                userData?.first_name ?
                <div className="get-invoice">
                  <button className="get" disabled={checking} onClick={handleInvoice}>Qpay-р төлөх</button>
                </div>
                :
                <div className="get-invoice">
                  <button className="get" disabled={checking} onClick={() => navigate("/school/signin")}>Нэвтрэх</button>
                </div>
              }

              { invoiceId ? <div className="check-payment">
                <button className="check" disabled={checking} onClick={checkInvoice}>Төлбөр шалгах</button>
              </div> : null
              }

              {paid || !qpayInvoice?.qr_image ? null :
              <div className="mobile-only">
                <div className="title">Гар утасны аппаар төлөх:</div>
                <div className="payment-apps">
                  {qpayInvoice?.urls.map((item, index) => (
                    <div key={index} className="payment-app">
                      <a href={item.link} target="_blank" rel="noopener noreferrer">
                        <img className="logo" src={item.logo} />
                        <div className="name">{item.description}</div>
                      </a>
                    </div>
                  ))}
                </div>
              </div>}
            </>
          }
        </div>
      }
    </div>
  );
};

export default Payment;
